import { Inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { DEFAULT_PAGE_SIZE } from '../../constants/commonConstants';
import { ENV_CONFIG } from 'src/app/core/injection.token';

type DynamicPaged<T> = app.models.DynamicResponse<app.models.PagedResult<T>>;

@Injectable()
export class AgentSyncLogsAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'Log';

  public getPagedAgentSyncLogs(pageIndex: number, pageFilter: app.models.GetPagedAgentSyncLogFilterModel) {
    let queryParams = {
      ...pageFilter,
      startDate: pageFilter.startDate ? pageFilter.startDate.toISOString() : null,
      endDate: pageFilter.endDate ? pageFilter.startDate.toISOString() : null,
      page: pageIndex,
      pageSize: DEFAULT_PAGE_SIZE,
    };

    const request = 'getPagedLogs';
    const url = this._apiService.buildUrl(
      this._envConfig.PORTAL_BACKEND_APISYNC_URL,
      this.controller,
      request,
      queryParams
    );

    return this._apiService.get<DynamicPaged<app.models.GetPagedAgentSyncLogModel>>(url);
  }
}
